module.exports = __webpack_public_path__ + "img/download_explain_1.22301172.png";